var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompare = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    d: "M11.997 24.946a.93.93 0 0 1-.923-.923V1.87a.93.93 0 0 1 .923-.923.93.93 0 0 1 .923.923v22.154a.93.93 0 0 1-.923.923z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    fillRule: "evenodd",
    d: "M11.076 5.254H7.384A3.077 3.077 0 0 0 4.307 8.33v9.23c0 1.7 1.378 3.078 3.077 3.078h3.692zM7.384 3.408A4.923 4.923 0 0 0 2.461 8.33v9.23a4.923 4.923 0 0 0 4.923 4.924h5.538V3.408z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    fillRule: "evenodd",
    d: "M11.078 3.408v1.846h1.384v-.892h.462v-.954zm4.153 0v1.846h1.385q.313 0 .602.058l.359-1.81a5 5 0 0 0-.961-.094zm4.12.829L18.324 5.77c.337.225.627.515.852.852l1.534-1.028a5 5 0 0 0-1.359-1.358zm2.188 12.17h-1.846v1.155q0 .311-.059.602l1.811.358q.093-.466.094-.96v-1.154zm-.83 3.89-1.533-1.027a3.1 3.1 0 0 1-.852.852l1.027 1.534c.537-.36 1-.822 1.359-1.359zm-7.785 2.188h-1.846v-1.846h1.384v.892h.462zM11.078 6.269h1.846v1.908h-1.846zm0 3.816h1.846v1.907h-1.846zm0 3.815h1.846v1.908h-1.846zm0 3.815h1.846v1.908h-1.846zm4.153 4.77v-1.846h1.385q.313 0 .602-.059l.359 1.811a5 5 0 0 1-.961.094zM21.54 14.1h-1.846v-2.308h1.846zm0-4.615h-1.846V8.33q0-.313-.059-.603l1.811-.358q.094.466.094.96z",
    clipRule: "evenodd"
  })));
};
export default SvgCompare;